import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Logo from '../../assets/Logo.png';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'center',
  },
  img: {
    width: '40%',
    margin: 'auto',
    display: 'block',
  },
}));

const SplashScreen = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img className={classes.img} src={Logo} alt="logo" />
    </div>
  );
};

export default React.memo(SplashScreen);
